import { render, staticRenderFns } from "./AppCardComponent.vue?vue&type=template&id=633c0dcf&scoped=true&"
import script from "./AppCardComponent.vue?vue&type=script&lang=js&"
export * from "./AppCardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633c0dcf",
  null
  
)

export default component.exports